import { HEROSECTION_MEDIA_SOURCES } from "../../../../utils/config/mediaSources/heroSection";
import { buildSrcSet } from "../../../../utils/index.ts";

export default function LeftImage() {

	return (
		<img
			src={HEROSECTION_MEDIA_SOURCES.heroSection.leftImageSet.img.defaultSrc}
			srcSet={buildSrcSet(HEROSECTION_MEDIA_SOURCES.heroSection.leftImageSet.srcSet)}
			sizes={`
				(max-width: 640px) 18vw,
				(max-width: 1024px) 18vw,
				(max-width: 1280px) 18vw,
				(max-width: 1536px) 18vw,
				18vw
			`}

			alt={HEROSECTION_MEDIA_SOURCES.heroSection.leftImageSet.img.alt}
			role="presentation"
			loading="eager"
			fetchPriority="high"
			width={HEROSECTION_MEDIA_SOURCES.heroSection.leftImageSet.img.width}
			height={HEROSECTION_MEDIA_SOURCES.heroSection.leftImageSet.img.height}
			className={`
				w-[65%] sm:w-[62%] lg:w-[58%] xl:w-[50%] 2xl:w-[48%] aspect-square
				relative top-[0] left-[-12vw] 
				drop-shadow-[-30px_30px_30px_rgba(0,0,0,0.3)] 2xl:drop-shadow-[-3vw_3vw_3vw_rgba(0,0,0,0.3)]
			`}
			decoding="sync"
		/>
	);
}